package org.matthewo.hooks

import react.StateInstance
import kotlin.reflect.KProperty

interface MutableState<T> {
    fun get(): T
    fun set(value: T)
    operator fun invoke() = get()
    operator fun invoke(value: T) = set(value)
    operator fun getValue(thisRef: Any?, property: KProperty<*>) = get()
    operator fun setValue(thisRef: Any?, property: KProperty<*>, value: T) = set(value)
}

val <T> StateInstance<T>.state
    get() = object : MutableState<T> {
        override fun set(value: T) = component2().invoke(value)
        override fun get() = component1()
    }
